<script setup lang="ts">
import { ArrowLeft } from '@element-plus/icons-vue'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { messageRecordDetail, recordSingleMarkRead } from '@mp/api/sdpMessage/MessageV2Controller.ts'
import { computed, ref } from 'vue'
import WujieVue from 'wujie-vue3'

const { bus } = WujieVue

const visible = ref<boolean>(false)
const messageId = ref<string>()

// #查看详情
const { data: detail, isLoading, remove } = useQuery({
  enabled: computed(() => Boolean(messageId.value)),
  queryKey: ['message/record/detail'],
  queryFn: () => messageRecordDetail({
    messageId: messageId.value as string,
  }),
  select: res => res.data,
})

// #设置已读
const { mutate: handleMarkRead } = useMutation({
  mutationFn: recordSingleMarkRead,
})

// ? 获取按钮
const actionButtons = computed(() => detail.value?.messageDsl.display?.buttons ?? [])

function handleClose() {
  visible.value = false
  messageId.value = undefined

  remove()
  bus.$emit('notice:detail:close')
}

function handleActionButtonClick(row: APISdpMessage.Pinyin_3) {
  if (row?.action?.type === 'open_url' && row?.action?.target)
    return window.open(row?.action?.target)
  handleClose()
}

defineExpose({
  open({ id }: { id: string }) {
    if (!id)
      throw new Error('Message ID cannot be empty')

    handleMarkRead({
      messageId: id,
    })
    messageId.value = id
    visible.value = true
  },
})
</script>

<template>
  <el-drawer v-model="visible" :size="750" title="通知详情" class="text-n-800" append-to-body :z-index="99999" @close="handleClose">
    <!-- <pre class="pre-code-container" title="detail">{{ detail }}</pre> -->
    <section class=" bg-white p-5 rounded-lg">
      <el-skeleton v-if="isLoading" :rows="5" />

      <h1 class=" textn--800 text-lg font-medium">
        {{ detail?.content?.title }}
      </h1>
      <label class="text-sm mt-1 text-n-90 block">{{ detail?.content?.subTitle }}</label>

      <p class="text-n-90 text-sm mt-2 mb-4">
        {{ detail?.sendTime }}
      </p>

      <article class="text-n-200 text-sm">
        {{ detail?.content?.body }}
      </article>

      <footer v-if="detail?.content?.footer" class="mt-4 text-n-200 text-sm">
        {{ detail?.content?.footer }}
      </footer>
    </section>
    <template #header>
      <div class=" flex items-center">
        <el-button :icon="ArrowLeft" text class="px-2! mr-2" @click="handleClose" />
        <label class=" text-base text-n-800 font-medium">通知详情</label>
      </div>
    </template>

    <template #footer>
      <template v-if="actionButtons.length > 0">
        <el-button v-for="(item, index) in actionButtons" :key="index" :type="item?.style?.type === 'primary' ? 'primary' : 'default'" @click="handleActionButtonClick(item)">
          {{ item.text }}
        </el-button>
      </template>
      <template v-else>
        <el-button @click="handleClose">
          关闭
        </el-button>
      </template>
    </template>
  </el-drawer>
</template>
